<!-- <div class="row row-sm add-form"> -->
<form autocomplete="off" class="p-0" novalidate [formGroup]="SessionCoClg ">
    <div class="col-lg-12 col-md-12">

        <div class="card-body">
            <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>
                            Course Intake Mapping
                        </b></h3>
                    <p class="text-muted card-sub-title mb-0">
                        Add New Course Intake Mapping
                    </p>
                </div>
            </div>
            <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>
                            Course Intake Mapping
                        </b></h3>
                    <p class="text-muted card-sub-title mb-0">
                        Edit Selected Course Intake Mapping
                    </p>
                </div>
            </div>
            <hr>
            <div class="row mt-0 ">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Session</mat-label>
                        <mat-select #select232 placeholder="Session" class="colorblack" formControlName="Session"
                            required>
                            <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                [displayMember]="'SnName'" [array]="sessionList"
                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo"
                                (click)="getSnId(item.SnNo)">
                                {{item.SnName}}
                            </mat-option>
                        </mat-select>
                        <mat-error class="margin_tp"
                            *ngIf="SessionCoClg.controls['Session'].touched && SessionCoClg.controls['Session'].errors?.required">
                            Mandatory
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-radio-group class="example-full-width" aria-label="Select an option" [disabled]="radioBtn"
                        formControlName="radio">
                        <div class="row">
                            <div class="col-sm-5  mt-2">
                                <mat-radio-button value="clg" (click)="clgClick()">By
                                    College</mat-radio-button>
                            </div>
                            <div class="col-sm-5 mt-2">
                                <mat-radio-button class="ml-1" value="course" (click)="courseClick()">By
                                    Course</mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>
                <div *ngIf="isShownCollegeDiv==true" class="col-sm-6">
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label> College Name</mat-label>
                        <mat-select [disabled]=" isCourseRadioBtn" #select23 placeholder="CoCode" class="colorblack"
                            formControlName="college">
                            <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                [displayMember]="'CgName'" [array]="collegeList"
                                (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode"
                                (click)="oneClgClick(item)">
                                {{item.CgCode}}-{{item.CgName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>
                <div *ngIf="isShownCourseDiv==true" class="col-sm-6">
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label> Course Name</mat-label>
                        <mat-select [disabled]="isCollegeRadioBtn" #select22 placeholder="CoCode" class="colorblack"
                            formControlName="course">
                            <mat-select-filter *ngIf="select22.focused" [placeholder]="'Filter'"
                                [displayMember]="'CoName'" [array]="courseList"
                                (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode"
                                (click)="oneCourseClick(item)">
                                {{item.CoCode}}-{{item.CoName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="isShownCollegeList==true" class="table-responsive table-container mt-3">
                <table  class="table table-bordered text-left">
                    <thead>
                        <tr>

                            <th class="f600 ">
                                Code </th>
                            <th class="f600 ">
                                College Name </th>
                            <th class="f600 text-center">
                                Recognized Intake </th>
                            <th class="f600 text-center">
                                Permitted Intake </th>
                        </tr>
                    </thead>
                    <tbody id="table_data" formArrayName="CollegeArr">
                        <tr *ngFor="let college of getControls(); let i = index" [formGroupName]="i">
                            <td>
                                {{college.value.CoCgCgCode}}
                            </td>
                            <td>
                                {{college.value.CgName}}
                            </td>
                            <td>
                                <input class="form-control text-center" formControlName="RecongnizedIntake"
                                    maxlength="4">
                                    <mat-error class="margin_tp mrgtp"
                                *ngIf="college.controls.RecongnizedIntake.touched && college.controls.RecongnizedIntake.errors?.required">
                                    Mandatory
                                </mat-error>

                            </td>
                            <td>
                                <input class="form-control text-center" formControlName="PermittedIntake" maxlength="4" (keyup)="intake($event,i,'CollegeArr')">
                                <mat-error class="margin_tp mrgtp"
                                *ngIf="college.controls.PermittedIntake.touched && college.controls.PermittedIntake.errors?.intakeError">
                                    Cannot Be More Than Recognized Intake
                                </mat-error>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="isShownCourseList==true" class="table-responsive table-container mt-3" formArrayName="CourseArr">
                <table  class="table table-bordered text-left">
                    <thead>
                        <tr>

                            <th class="f600 ">
                                Code </th>
                            <th class="f600 ">
                                Course Name </th>
                            <th class="f600 text-center">
                                Recognized Intake </th>
                            <th class="f600 text-center">
                                Permitted Intake </th>
                        </tr>
                    </thead>
                    <tbody id="table_data">
                        <tr *ngFor="let course of getControls1(); let i = index" [formGroupName]="i">
                            <td class="text-left">
                                {{course.value.CoCgCoCode}}
                            </td>
                            <td class="text-left">
                                {{course.value.CoName}}
                            </td>
                            <td>
                                <input class="form-control text-center" formControlName="RecongnizedIntake"
                                    maxlength="4">
                                <span class="red" *ngIf=" errorcheckR(course)">
                                    Invalid
                                </span>
                                <mat-error class="margin_tp mrgtp"
                                *ngIf="course.controls.RecongnizedIntake.touched && course.controls.RecongnizedIntake.errors?.required">
                                    Mandatory
                                </mat-error>
                            </td>
                            <td>
                                <input class="form-control text-center" formControlName="PermittedIntake" maxlength="4" (keyup)="intake($event,i,'CourseArr')">
                                <span class="red" *ngIf=" errorcheckP(course)">
                                    Invalid
                                </span>
                                <mat-error class="margin_tp mrgtp"
                                *ngIf="course.controls.PermittedIntake.touched && course.controls.PermittedIntake.errors?.intakeError">
                                    Cannot Be More Than Recognized Intake
                                </mat-error>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
                <div class="row col-sm-12">
                    <div class="col-sm-12 prpl">
                        <button *ngIf="submitcollege && sessCreate" type="button"
                            class="btn btn-primary btn-icon-text floatright mt-1 fr" (click)="submitFun1()">
                            <span style="display: flex; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                <!-- {{'header.college-data.titleList.Update' | translate }} -->
                                Save
                            </span>
                        </button>
                        <button *ngIf="submitcourse && sessCreate" type="button"
                            class="btn btn-primary btn-icon-text floatright mt-1 fr" (click)="submitFun()">
                            <span style="display: flex; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mt-1 mr-3 fr">
                            <span style="display: flex; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
                
            </div>

            
        </div>

    </div>
</form>
<!-- </div> -->